import { useAuth } from 'routes/Menu/domains/auth'

export const useIsBlackFridayPromotion = (): boolean => {
  const { isAuthenticated } = useAuth()

  return !isAuthenticated
}
